import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Pagination } from '@models/pagination';
import { parseApiInstant } from '../../shared/util/parse-api-instant';

@Component({
    selector: "app-historical-requirement",
    templateUrl: "./historical-requirement.component.html",
    styleUrls: ["./historical-requirement.component.scss"],
    standalone: false,
    providers: [DatePipe]
})
export class HistoricalRequirementComponent implements OnInit, OnChanges {
  @Input() historials: Object[];
  @Output()  loadHistoryLog = new EventEmitter<boolean>();
  displayedColumns = ["date", "user", "description"];
  pagination: Pagination;
  skip: string;
  take: string;

  ngOnInit() {
    this.pagination = new Pagination();
    this.pagination.current_page = 1;
    this.pagination.per_page = 10;
    this.pagination.total = this.historials ? this.historials.length : 0;
    this.skip = ((this.pagination.current_page - 1) * this.pagination.per_page).toString();
    this.take = ((this.pagination.current_page - 1) * this.pagination.per_page + this.pagination.per_page).toString();
    this.sortHistorialsDesc();
  }

  constructor(private datePipe: DatePipe) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['historials'] && this.pagination) {
      this.pagination.total = this.historials?.length ?? 0;
      if (this.historials?.length) {
        this.sortHistorialsDesc();
      }
      const maxPage = Math.max(
        1,
        Math.ceil((this.historials?.length ?? 0) / Number(this.pagination.per_page))
      );
      if (this.pagination.current_page > maxPage) {
        this.pagination.current_page = maxPage;
      }
    }
  }

  sortHistorialsDesc(): void {
    if (!this.historials?.length) {
      return;
    }
    this.historials.sort((a: any, b: any) => {
      const dateA = parseApiInstant(a.date)?.getTime() ?? 0;
      const dateB = parseApiInstant(b.date)?.getTime() ?? 0;
      return dateB - dateA;
    });
  }

  /** Página actual sobre la copia ordenada en memoria (el GET devuelve todos los logs). */
  get pagedHistorials(): Object[] {
    if (!this.historials?.length || !this.pagination) {
      return [];
    }
    const pageSize = Number(this.pagination.per_page);
    const start = (this.pagination.current_page - 1) * pageSize;
    return this.historials.slice(start, start + pageSize);
  }

  formatLogDate(date: string | Date | null | undefined): string {
    const instant = parseApiInstant(date);
    if (!instant) {
      return 'Sin Fecha';
    }
    return (
      this.datePipe.transform(
        instant,
        'MMM d, y h:mm a',
        undefined,
        'en-US'
      ) ?? 'Sin Fecha'
    );
  }

  getTypeOfHistorial(row) {
    // Debe ir antes de "filename": las ediciones online también traen filename
    if (row && (row.editedOnline === true || row.hasOwnProperty('editedOnline'))) {
      return 'editedOnline';
    }
    if (row.hasOwnProperty("filename")) {
      return "file";
    }
       if (row.hasOwnProperty("fieldsupdated")) {
      return "fieldsupdated";
    }
    if (row.hasOwnProperty("assigneduser")) {
      return "assigned";
    }
    if (row.hasOwnProperty("status1")) {
      if(row["status1"] == 'Created'){
        return "created";
      } else {
        return "status";
      }
    }
    if (row.hasOwnProperty("note")) {
      return "note";
    }

    return "undefined"
  }

  pageChanged(page: number): void {
    this.pagination.current_page = page;
    this.skip = ((this.pagination.current_page - 1) * this.pagination.per_page).toString();
    this.take = (
      (this.pagination.current_page - 1) * this.pagination.per_page +
      this.pagination.per_page
    ).toString();
  }

  refreshCountries() {
    this.pagination.current_page = 1;
    this.skip = '0';
    this.take = String(this.pagination.per_page);
  }
}
